/**
 * Assert a condition is truthy. Crashes immediately with a descriptive message
 * if the condition is false. Use this instead of `if (!x) return undefined`
 * when the data MUST exist.
 */
export function invariant(condition: unknown, message: string): asserts condition {
	if (!condition) {
		throw new Error(`Invariant violation: ${message}`);
	}
}
